// // pages/about/AboutSections.jsx
// import { useEffect, useState } from "react";
// import {
//   Button,
//   Tabs,
//   Table,
//   Modal,
//   Form,
//   Input,
//   InputNumber,
//   Switch,
//   Segmented,
//   ColorPicker,
//   Tag,
//   Space,
// } from "antd";
// import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import api from "../../api";
// import { useToast } from "../../components/toast";
// import ConfirmModal from "../../components/modal/ConfirmModal";
// import Editor from "../../components/editor/Editor";
// import ImageField from "../../components/media/ImageField";

// const TYPES = [
//   { key: "HERO", label: "Hero" },
//   { key: "VALUE", label: "Үнэт зүйлс" },
//   { key: "STORY", label: "Хэсгүүд" },
// ];

// const BG_PRESETS = [
//   { label: "Өнгөнүүд", colors: ["#f0fdf4", "#eff6ff", "#f3e8f3", "#f3eee8"] },
// ];

// export default function AboutSections() {
//   const [type, setType] = useState("STORY");
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [editing, setEditing] = useState(null); // null: хаалттай, {}: шинэ
//   const [saving, setSaving] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [form] = Form.useForm();
//   const toast = useToast();

//   const fetchRows = async () => {
//     setLoading(true);
//     const res = await api.about_list();
//     if (res?.status === 200) setRows(res.data || []);
//     else toast("Мэдээлэл татахад алдаа гарлаа", "error");
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchRows();
//   }, []);

//   const handleSubmit = async (values) => {
//     setSaving(true);
//     const payload = { ...values, type };
//     const res = editing?.id
//       ? await api.about_update(editing.id, payload)
//       : await api.about_create(payload);

//     if ([200, 201].includes(res?.status)) {
//       toast("Хадгалагдлаа", "success");
//       setEditing(null);
//       fetchRows();
//     } else {
//       toast(res?.data?.message || "Хадгалахад алдаа гарлаа", "error");
//     }
//     setSaving(false);
//   };

//   const handleDelete = async () => {
//     const res = await api.about_delete(deleteId);
//     if ([200, 204].includes(res?.status)) {
//       toast("Устгагдлаа", "success");
//       fetchRows();
//     } else {
//       toast("Устгахад алдаа гарлаа", "error");
//     }
//     setDeleteId(null);
//   };

//   const columns = [
//     { title: "#", dataIndex: "order", width: 60 },
//     {
//       title: type === "VALUE" ? "Icon" : "Зураг",
//       width: 90,
//       render: (_, r) =>
//         r.icon || r.image ? (
//           <img
//             src={r.icon || r.image}
//             alt=""
//             style={{ width: 48, height: 48, objectFit: "contain" }}
//           />
//         ) : (
//           "-"
//         ),
//     },
//     { title: "Гарчиг", dataIndex: "title" },
//     {
//       title: "Төлөв",
//       dataIndex: "isActive",
//       width: 110,
//       render: (v) =>
//         v ? <Tag color="green">Идэвхтэй</Tag> : <Tag>Идэвхгүй</Tag>,
//     },
//     {
//       title: "",
//       width: 100,
//       render: (_, r) => (
//         <Space>
//           <Button
//             size="small"
//             icon={<EditOutlined />}
//             onClick={() => setEditing(r)}
//           />
//           <Button
//             size="small"
//             danger
//             icon={<DeleteOutlined />}
//             onClick={() => setDeleteId(r.id)}
//           />
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <section className="about-sections-page">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4 className="m-0">Бидний тухай</h4>
//         <Button
//           type="primary"
//           icon={<PlusOutlined />}
//           onClick={() => setEditing({})}
//         >
//           Нэмэх
//         </Button>
//       </div>

//       <Tabs activeKey={type} onChange={setType} items={TYPES} />

//       <Table
//         rowKey="id"
//         loading={loading}
//         columns={columns}
//         dataSource={rows.filter((r) => r.type === type)}
//         pagination={false}
//       />

//       <Modal
//         open={!!editing}
//         title={editing?.id ? "Засах" : "Шинээр нэмэх"}
//         onCancel={() => setEditing(null)}
//         onOk={() => form.submit()}
//         okText="Хадгалах"
//         cancelText="Болих"
//         confirmLoading={saving}
//         width={720}
//         destroyOnHidden
//       >
//         <Form
//           key={editing?.id ?? "new"}
//           form={form}
//           layout="vertical"
//           preserve={false}
//           onFinish={handleSubmit}
//           initialValues={{
//             imagePosition: "RIGHT",
//             order: 0,
//             isActive: true,
//             ...editing,
//           }}
//         >
//           <Form.Item
//             name="title"
//             label="Гарчиг"
//             rules={[{ required: true, message: "Гарчиг оруулна уу" }]}
//           >
//             <Input />
//           </Form.Item>

//           <Form.Item name="description" label="Тайлбар">
//             {type === "STORY" ? (
//               <Editor
//                 preset="basic"
//                 minHeight={120}
//                 placeholder="Тайлбар бичнэ үү..."
//                 className="about-editor"
//               />
//             ) : (
//               <Input.TextArea autoSize={{ minRows: 3, maxRows: 8 }} />
//             )}
//           </Form.Item>

//           {type === "VALUE" ? (
//             <Form.Item name="icon" label="Icon">
//               <ImageField />
//             </Form.Item>
//           ) : (
//             <Form.Item name="image" label="Зураг">
//               <ImageField />
//             </Form.Item>
//           )}

//           {type === "STORY" && (
//             <div className="d-flex gap-4">
//               <Form.Item
//                 name="bgColor"
//                 label="Фон өнгө"
//                 getValueFromEvent={(color) => color?.toHexString()}
//               >
//                 <ColorPicker presets={BG_PRESETS} showText />
//               </Form.Item>
//               <Form.Item name="imagePosition" label="Зургийн байрлал">
//                 <Segmented
//                   options={[
//                     { label: "Зүүн", value: "LEFT" },
//                     { label: "Баруун", value: "RIGHT" },
//                   ]}
//                 />
//               </Form.Item>
//             </div>
//           )}

//           <div className="d-flex gap-4">
//             <Form.Item name="order" label="Дараалал">
//               <InputNumber min={0} />
//             </Form.Item>
//             <Form.Item name="isActive" label="Идэвхтэй" valuePropName="checked">
//               <Switch />
//             </Form.Item>
//           </div>
//         </Form>
//       </Modal>

//       <ConfirmModal
//         variant="error"
//         title="Итгэлтэй байна уу?"
//         showModal={!!deleteId}
//         setShowModal={(v) => !v && setDeleteId(null)}
//         submitHandler={handleDelete}
//         description="Устгасан хэсгийг сэргээх боломжгүй."
//       />
//     </section>
//   );
// }

import { useEffect, useState } from "react";
import { Button, Tabs, Table, Tag, Space } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../api";
import { useToast } from "../../components/toast";
import ConfirmModal from "../../components/modal/ConfirmModal";
import AboutSectionModal from "./AboutSectionModal";

const TYPES = [
  { key: "HERO", label: "Hero" },
  { key: "VALUE", label: "Үнэт зүйлс" },
  { key: "STORY", label: "Хэсгүүд" },
];

export default function AboutSections() {
  const [type, setType] = useState("STORY");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null); // null: хаалттай, {}: шинэ
  const [deleteId, setDeleteId] = useState(null);
  const toast = useToast();

  const fetchRows = async () => {
    setLoading(true);
    const res = await api.about_list();
    if (res?.status === 200) setRows(res.data || []);
    else toast("Мэдээлэл татахад алдаа гарлаа", "error");
    setLoading(false);
  };

  useEffect(() => {
    fetchRows();
  }, []);

  const handleDelete = async () => {
    const res = await api.about_delete(deleteId);
    if ([200, 204].includes(res?.status)) {
      toast("Устгагдлаа", "success");
      fetchRows();
    } else {
      toast("Устгахад алдаа гарлаа", "error");
    }
    setDeleteId(null);
  };

  const columns = [
    { title: "#", dataIndex: "order", width: 60 },
    {
      title: type === "VALUE" ? "Icon" : "Зураг",
      width: 90,
      render: (_, r) =>
        r.icon || r.image ? (
          <img
            src={r.icon || r.image}
            alt=""
            style={{ width: 48, height: 48, objectFit: "contain" }}
          />
        ) : (
          "-"
        ),
    },
    { title: "Гарчиг", dataIndex: "title" },
    {
      title: "Төлөв",
      dataIndex: "isActive",
      width: 110,
      render: (v) =>
        v ? <Tag color="green">Идэвхтэй</Tag> : <Tag>Идэвхгүй</Tag>,
    },
    {
      title: "",
      width: 100,
      render: (_, r) => (
        <Space>
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => setEditing(r)}
          />
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => setDeleteId(r.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <section className="about-sections-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">Бидний тухай</h4>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setEditing({})}
        >
          Нэмэх
        </Button>
      </div>

      <Tabs activeKey={type} onChange={setType} items={TYPES} />

      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={rows.filter((r) => r.type === type)}
        pagination={false}
      />

      {editing && (
        <AboutSectionModal
          key={editing.id ?? "new"}
          type={type}
          editing={editing}
          onClose={() => setEditing(null)}
          onSuccess={fetchRows}
        />
      )}

      <ConfirmModal
        variant="error"
        title="Итгэлтэй байна уу?"
        showModal={!!deleteId}
        setShowModal={(v) => !v && setDeleteId(null)}
        submitHandler={handleDelete}
        description="Устгасан хэсгийг сэргээх боломжгүй."
      />
    </section>
  );
}
